module.exports = __webpack_public_path__ + "static/media/defaultAvatar22.18a3dba0.svg";